import { render, staticRenderFns } from "./Logbooks.vue?vue&type=template&id=bcf23988&scoped=true&"
import script from "./Logbooks.vue?vue&type=script&lang=js&"
export * from "./Logbooks.vue?vue&type=script&lang=js&"
import style0 from "./Logbooks.vue?vue&type=style&index=0&id=bcf23988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf23988",
  null
  
)

export default component.exports